import { TableCellProps, Typography, TypographyProps } from '@mui/material';
import { CSSProperties } from 'react';

function BudgetTypography({
  value,
  color,
  align = 'left',
  style,
  fontSize,
  ...props
}: TypographyProps & {
  value: string | number;
  color: string;
  fontSize?: string | number;
  align?: TableCellProps['align'];
  style?: CSSProperties;
}) {
  return (
    <Typography
      color={color}
      fontWeight={700}
      fontSize={fontSize ?? '0.875rem'}
      textTransform="uppercase"
      letterSpacing={0.04}
      align={align}
      style={style}
      {...props}
    >
      {value}
    </Typography>
  );
}
export default BudgetTypography;
